module.exports = __webpack_public_path__ + "media/images/new/roadpass_pro_phone-040b8bbe7e95f03086fe3fdbb6066c4d.png";